<template>
    <div class="main-cn">
      <div class="main-hd">
        <h4>修改密码</h4>
      </div>
      <div class="main-bd mg20">
        <el-row v-watermask >
          <el-col :span="12">
            <sub-change-pwd-form v-if="user.id > 0" :model="user" :scenario="'update'" @submit="submitForm($event)"></sub-change-pwd-form>
          </el-col>
        </el-row>
      </div>
    </div>
  </template>
  
  <script>
  import UserService from "~/services/user";
  import subChangePwdForm from "~/views/user/changePwdForm.vue";
  
  export default {
      components: {
        subChangePwdForm
      },
      data() {
          return {
              user: null
          };
      },
      created() {
          if (this.user == null) {
              this.user = UserService.getModel();
          }
  
          this.getUserInfo(this.$route.query["id"]);
      },
  
      methods: {
          getUserInfo(userId) {
              if (parseInt(userId) < 1) {
                  return false;
              }
              UserService.getInfo(userId).then(res => {
                  if (res.code == 0) {
                      this.user = res.data;
  
                      // 此处为了兼容 Switch 开关控件不得不强转成字符串
                      if (typeof this.user.status == "number") {
                          this.user.status = this.user.status.toString();
                      }
  
                      if (typeof this.user.is_common == "number") {
                          this.user.is_common = this.user.is_common.toString();
                      }
  
                      return true;
                  } else {
                      return false;
                  }
              });
          },
  
          submitForm(user) {
            console.log('修改密码提交：', user);
              UserService.changePwd(user).then(res => {
                  if (res.code == 0) {
                      this.$message({
                          message: "保存成功!",
                          type: "success",
                          showClose: true,
                      });
  
                      this.$router.push({
                          path: "/users/index",
                      });
                  }
              });
          }
      }
  };
  </script>
  


// WEBPACK FOOTER //
// src/views/user/changePwd.vue